import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M34.28 9.83008C34.28 9.13972 34.8397 8.58008 35.53 8.58008C36.2204 8.58008 36.78 9.13972 36.78 9.83008V39.3301C36.78 40.0204 36.2204 40.5801 35.53 40.5801C34.8397 40.5801 34.28 40.0204 34.28 39.3301V9.83008Z M15.4194 8.8909C15.1524 8.68762 14.8495 8.58044 14.5412 8.58008C14.2328 8.57972 13.9299 8.68682 13.6626 8.88948C13.3952 9.09214 13.1729 9.3833 13.018 9.73485C12.8632 10.0864 12.7811 10.4859 12.78 10.8924V38.2684C12.7811 38.675 12.8632 39.0738 13.018 39.4253C13.1729 39.7769 13.3952 40.0687 13.6626 40.2714C13.9299 40.474 14.2328 40.5804 14.5412 40.5801C14.8495 40.5797 15.1524 40.4725 15.4194 40.2693L33.4109 26.5813C33.6755 26.3766 33.8949 26.0841 34.0474 25.7331C34.1998 25.3821 34.28 24.9849 34.28 24.5804C34.28 24.1759 34.1998 23.7781 34.0474 23.4271C33.8949 23.0761 33.6755 22.7843 33.4109 22.5796L15.4194 8.8909ZM31.7527 24.4196L31.7535 24.4213L31.7527 24.4196ZM31.7689 24.4716C31.7749 24.4991 31.78 24.5361 31.78 24.5804C31.78 24.625 31.7748 24.6619 31.7688 24.6893L15.28 37.234V11.9262L31.7689 24.4716Z';
var filledPath = 'M14.4311 8.58008C14.7395 8.58044 15.0423 8.68762 15.3094 8.8909L33.3009 22.5796C33.5655 22.7843 33.7849 23.0761 33.9373 23.4271C34.0898 23.7781 34.17 24.1759 34.17 24.5804C34.17 24.9849 34.0898 25.3821 33.9373 25.7331C33.7849 26.0841 33.5655 26.3766 33.3009 26.5813L15.3094 40.2693C15.0423 40.4725 14.7395 40.5797 14.4311 40.5801C14.1228 40.5804 13.8198 40.474 13.5525 40.2714C13.2852 40.0687 13.0629 39.7769 12.908 39.4253C12.7531 39.0738 12.6711 38.675 12.67 38.2684V10.8924C12.6711 10.4859 12.7531 10.0864 12.908 9.73485C13.0629 9.3833 13.2852 9.09214 13.5525 8.88948C13.8198 8.68682 14.1228 8.57972 14.4311 8.58008Z M34.17 24.5804V9.83008C34.17 9.13972 34.7296 8.58008 35.42 8.58008C36.1103 8.58008 36.67 9.13972 36.67 9.83008V39.3301C36.67 40.0204 36.1103 40.5801 35.42 40.5801C34.7296 40.5801 34.17 40.0204 34.17 39.3301V24.5804Z';
var FastForwardEndIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
FastForwardEndIcon.displayName = 'FastForwardEndIcon';
FastForwardEndIcon.defaultProps = {
  'aria-label': 'Fast Forward to End'
};
export default FastForwardEndIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/FastForwardEndIcon/index.js
// module id = 1841
// module chunks = 12